var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.wrapper, ( _obj = {}, _obj[_vm.$style.isLoading] = _vm.isLoading, _obj )]},[(_vm.isLoading)?_c('Spinner',{class:_vm.$style.spinner,attrs:{"appearance":"dark"}}):_vm._e(),(!_vm.isLoading)?_c('div',{class:_vm.$style.content},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }